import {
  ISourceEntityHandler,
  type ISource,
} from '@principle-theorem/practice-migrations/interfaces';
import { BaseSourceHandler } from '../source/base-source-handler';
import { ADAItemSourceEntity } from './source/entities/ada-item';
import { AppointmentCategorySourceEntity } from './source/entities/appointment-category';
import { ContactsSourceEntity } from './source/entities/contacts';
import { FeeScheduleSourceEntity } from './source/entities/fee-schedule';
import { PatientSourceEntity } from './source/entities/patient';
import { AppointmentSourceEntity } from './source/entities/patient-appointment';
import { PatientBalanceSourceEntity } from './source/entities/patient-balance';
import { PatientDocumentsSourceEntity } from './source/entities/patient-documents';
import { PatientExternalLinksSourceEntity } from './source/entities/patient-external-links';
import { PatientNotesSourceEntity } from './source/entities/patient-notes';
import { PatientPerioExamsSourceEntity } from './source/entities/patient-perio-exams';
import { PatientTransactionsSourceEntity } from './source/entities/patient-transactions';
import { PatientTreatmentSourceEntity } from './source/entities/patient-treatments';
import { StafferSourceEntity } from './source/entities/staff';
import { UsedItemCodeConditionSourceEntity } from './source/entities/used-item-code-conditions';
import { UsedItemCodeTreatmentSourceEntity } from './source/entities/used-item-code-treatments';
import { NoteItemCodeTreatmentSourceEntity } from './source/entities/note-item-code-treatments';
import { AppointmentRoomSourceEntity } from './source/entities/appointment-room';
import { ExactContactTranslator } from './sql-seeding-translators/contact';
import { PatientBPESourceEntity } from './source/entities/patient-bpe-scores';
import { PatientMedicalHistoriesSourceEntity } from './source/entities/patient-medical-histories';
import { PatientPathologyNotesSourceEntity } from './source/entities/patient-pathology-notes';
import { AgreementHoldersV2SourceEntity } from './source/entities/agreement-holders-v2';
import { PatientBalancesV2SourceEntity } from './source/entities/patient-balances-v2';
import { PatientInvoiceLinesV2SourceEntity } from './source/entities/patient-invoice-lines-v2';
import { PatientTransactionsV2SourceEntity } from './source/entities/patient-transactions-v2';
import { PaymentMethodsV2SourceEntity } from './source/entities/payment-methods-v2';
import { TransactionAllocationsV2SourceEntity } from './source/entities/transaction-allocations-v2';

export const EXACT_SOURCE_V2: ISource = {
  metadata: {
    name: 'Exact',
    version: 'v2',
  },
  configuration: [
    {
      name: 'Practice Id',
      description: 'Exact Practice Id',
      value: '',
    },
    {
      name: 'Database Name',
      description: 'Database Name',
      value: '',
    },
    {
      name: 'Database Username',
      description: 'Database Username',
      value: '',
    },
    {
      name: 'Database Password',
      description: 'Database Password',
      value: '',
    },
    {
      name: 'Database Connection Name',
      description:
        'Fully Qualified Name of Database. Eg. "practice-migrations:australia-southeast1:[instance_name]"',
      value: '',
    },
    {
      name: 'Source Bucket Storage Path',
      description: `Bucket storage path that patient files live under Eg. "gs://practice-name'`,
      value: '',
    },
  ],
};

export class ExactSourceHandlerV2 extends BaseSourceHandler {
  migrationType = 'Exact';
  migrationVersion = 'v2';
  source = EXACT_SOURCE_V2;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityHandlers: ISourceEntityHandler<any>[] = [
    new StafferSourceEntity(),
    new PatientSourceEntity(),
    new ADAItemSourceEntity(),
    new ContactsSourceEntity(),
    new AppointmentSourceEntity(),
    new PatientTreatmentSourceEntity(),
    new FeeScheduleSourceEntity(),
    new PatientNotesSourceEntity(),
    new PatientPerioExamsSourceEntity(),
    new PatientTransactionsSourceEntity(),
    new PatientBalanceSourceEntity(),
    new PatientDocumentsSourceEntity(),
    new PatientExternalLinksSourceEntity(),
    new AppointmentCategorySourceEntity(),
    new UsedItemCodeConditionSourceEntity(),
    new UsedItemCodeTreatmentSourceEntity(),
    new NoteItemCodeTreatmentSourceEntity(),
    new AppointmentRoomSourceEntity(),
    new PatientBPESourceEntity(),
    new PatientPathologyNotesSourceEntity(),
    new PatientMedicalHistoriesSourceEntity(),
    new PatientTransactionsV2SourceEntity(),
    new PatientInvoiceLinesV2SourceEntity(),
    new TransactionAllocationsV2SourceEntity(),
    new PatientBalancesV2SourceEntity(),
    new AgreementHoldersV2SourceEntity(),
    new PaymentMethodsV2SourceEntity(),
  ];

  sqlSeedingTranslators = [new ExactContactTranslator()];
}
